
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useRoutes } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import SplashView from '../pages/Splash/Splash';
import ServerErr from '../components/Errors/500';
import DesktopHeader from '../components/DesktopHeader/DesktopHeader';
import Menu from '../components/Menu/Menu';
import { useUserInfo } from '../pages/Profile/connect/User';
import routes from '../routes';
import { useOrders } from '../pages/DefaultPage/connect/Orders';


function MobileLayout() {
  const [showSplash, setShowSplash] = useState(false);
  const { getUserInfo, getIsBusinessUser, getUserInfoWithMobile } = useUserInfo(
    (state) => state.actions
  );
  const userInfoWithMobile = useUserInfo((state) => state.userInfoWithMobile);
  const loader = useUserInfo((state) => state.loader);

  const navigate = useNavigate();
  const showServerError = useOrders((state) => state.showServerError);
  let router = useRoutes(routes);
  const location = useLocation();

  const getUserInfoWithMobileHandler = async () => {
    await getUserInfoWithMobile(
      localStorage.getItem("phoneNumber")
        ? localStorage.getItem("phoneNumber")
        : localStorage.getItem("mergedValue")
    );
  };

  useEffect(() => {
    // getUserInfoWithMobileHandler();
    let darkMode = localStorage.getItem("veeu-dark-mode");
    if (darkMode === "true") {
      document.getElementById("root").classList.add("dark-mode");
    } else {
      document.getElementById("root").classList.remove("dark-mode");
    }

    // if (location.pathname == "/") {
    //   setShowSplash(true)
    //   setTimeout(() => {
    //     setShowSplash(false)
    //   }, 3500);
    // }
    console.log("userInfoWithMobile");
    console.log(userInfoWithMobile);
    // if (userInfoWithMobile.length == 0) {
    //   // localStorage.clear()
    //   console.log("userInfoWithMobile");
    //   console.log(userInfoWithMobile);
    // }
  }, []);

  

  return (
    <>
      <div className='hidden sm:block md:block lg:block'>
        {
          showSplash ? (
            <SplashView />
          ) : (
            <>
              {
                showServerError ? (
                  <ServerErr />
                ) : (
                  location.pathname.slice(0, 16) == "/AdvertiseDetail" ||
                    location.pathname.slice(0, 11) == "/RegisterAD" ||
                    location.pathname === "/LoginStepOne" ||
                    location.pathname === "/LoginLocation" ||
                    location.pathname === "/LoginSecondStep" ||
                    location.pathname === "/LoginStepThird" ||
                    location.pathname === "/Messages" ||
                    location.pathname === "/SplashView" ? (
                    <div className='w-full flex items-center justify-center '>
                      <div className='w-full'>
                        <DesktopHeader />
                        {router}
                      </div>
                    </div>
                  ) : (
                    <div className='h-full flex flex-col gap-[150px] '>
                      <div className='w-full flex  justify-center ' >
                        <div className='w-full '>
                          <DesktopHeader />
                          {router}
                        </div>
                      </div>
                      <Menu />
                    </div>
                  )
                )
              }

            </>
          )
        }
      </div>
    </>
  );
}

export default MobileLayout;
